import { Grid, Typography, RadioGroup, Radio, FormControlLabel, TextField as MuiTextField, FormControl, FormLabel, MenuItem } from '@material-ui/core';
import { useFormikContext, ErrorMessage, Field } from "formik";
import { TextField, Checkbox } from "formik-material-ui";
import { DatePicker } from "formik-material-ui-pickers";
import { EditRequest } from "./EditRequest"
import { ProductSearch } from 'components';
import { useContext } from 'react';
import { applicationContext } from 'helpers/services';
import { ReferenceData } from 'helpers/enums';
import { Autocomplete } from 'formik-material-ui-lab';
import { ticketContext } from 'views/Ticket/TicketContext';
import { KeyValuePair } from 'helpers';


let ProductInfo = () => {
    let { referenceData } = useContext(applicationContext);
    let form = useFormikContext<EditRequest>();
    let service = useContext(ticketContext);


    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary">Product info</Typography>
            </Grid>

            <Grid container item xs={12}>
                <Field
                    component={TextField}
                    name="deliveryNote"
                    variant="outlined"
                    fullWidth
                    label="Delivery Note"
                />
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Field
                        component={DatePicker}
                        name="invoiceDate"
                        fullWidth
                        format="LL"
                        inputVariant="outlined"
                        label="Invoice Date"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="invoiceNumber"
                        fullWidth
                        variant="outlined"
                        label="Invoice Number"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    <ProductSearch
                        label="Product"
                        freeSolo={false}
                        value={{
                            value: form.values.productSku,
                            label: `${form.values.productSku} ${form.values.productDescription}`.trim(),
                            brand: form.values.productBrand,
                            shortDescription: form.values.productDescription,
                            sku: form.values.productSku,
                            hasSerialNumber: form.values.hasSerialNumber, 
                            suppliers: service.productSuppliers
                        }}
                        onChange={(sku: string, brand: string, description: string, hasSerialNumber: boolean, suppliers: KeyValuePair<string, string>[]) => {
                            form.setFieldValue('productSku', sku);
                            form.setFieldValue('productBrand', brand);
                            form.setFieldValue('productDescription', description);
                            form.setFieldValue('hasSerialNumber', hasSerialNumber);

                            service.updateProductSuppliers(suppliers);
                        }}
                        error={Boolean(form.touched.productSku && form.errors.productSku)}
                        helperText={form.touched.productSku ? form.errors.productSku : ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Field
                        component={TextField}
                        name="productQuantity"
                        fullWidth
                        variant="outlined"
                        label="Quantity"
                        type="number"
                    />
                </Grid>
                {service.productSuppliers.length > 0 &&
                    <Grid item xs={12}>
                        <Field
                            component={TextField}
                            select
                            name="productSupplierCode"
                            variant="outlined"
                            fullWidth
                            onChange={(e: any) => {
                                form.setFieldValue('productSupplierCode', e.target.value);
                                form.setFieldValue('productSupplierName', service.productSuppliers.getValueByKey(e.target.value));
                            }}
                            label="Product supplier"
                        >
                            <MenuItem key={''} value={''}>Any</MenuItem>
                            {service.productSuppliers.map((supplier, supplierIdx) =>
                                <MenuItem key={supplierIdx} value={supplier.key}>{supplier.value}</MenuItem>
                            )}
                        </Field>
                    </Grid>
                }
            </Grid>
            <Grid container alignItems='center'>
                <Grid item>
                    <FormControl>
                        <FormLabel>Product condition</FormLabel>
                        <RadioGroup
                            row
                            value={form.values.productIsNew}
                            onChange={e => form.setFieldValue('productIsNew', e.target.value)}
                        >
                            <FormControlLabel value='new' control={<Radio />} label="New" />
                            <FormControlLabel value='used' control={<Radio />} label="Used" />
                        </RadioGroup>
                        <ErrorMessage name="productIsNew">
                            {msg => <Typography variant="caption" color="error">{msg}</Typography>}
                        </ErrorMessage>
                    </FormControl>
                </Grid>
                <Grid item xs>
                    <Field
                        fullWidth
                        name="purchaseCountry"
                        component={Autocomplete}
                        options={referenceData.getByKey(ReferenceData.Country)?.values.map(x => x.key)}
                        getOptionLabel={(option: string) => referenceData.getByKey(ReferenceData.Country)?.values.getValueByKey(option)}
                        renderInput={(params: any) =>
                            <MuiTextField
                                {...params}
                                fullWidth
                                variant="outlined"
                                label="Purchase country"
                            />
                        }
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={DatePicker}
                        name="purchaseDate"
                        fullWidth
                        format="LL"
                        inputVariant="outlined"
                        label="Purchase date"
                        clearable
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    <Typography variant="body2" color="textSecondary">Product is under warranty?</Typography>
                    <RadioGroup
                        row
                        value={form.values.productIsUnderWarranty}
                        onChange={(e) => { form.setFieldValue('productIsUnderWarranty', e.target.value === "true") }}
                    >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>

                </Grid>

                <Grid item xs>
                    <Typography variant="body2" color="textSecondary">Have you got end user purchase receipt?</Typography>
                    <RadioGroup
                        row
                        value={form.values.hasPurchaseReceipt}
                        onChange={(e) => { form.setFieldValue('hasPurchaseReceipt', e.target.value === "true") }}
                    >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>

                </Grid>

                <Grid item xs>
                    <Typography variant="body2" color={"textSecondary"}>Can you repair product yourself?</Typography>
                    <RadioGroup
                        row
                        value={form.values.canYouRepairProductYourself}
                        onChange={(e) => { form.setFieldValue('canYouRepairProductYourself', e.target.value === "true") }}
                    >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>

                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="serialNumber"
                        fullWidth
                        variant="outlined"
                        label="Serial Number"
                        helperText={form.values.hasSerialNumber ? 'Remember to provide serial number' : ''}
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="suggestedAction"
                        fullWidth
                        variant="outlined"
                        label="Suggested Action"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        label="End customers has registered product on warranty website"
                        name="endCustomersHasRegisteredProduct"
                        value={form.values.endCustomersHasRegisteredProduct}
                        checked={form.values.endCustomersHasRegisteredProduct}
                        onChange={(e: any) => form.setFieldValue('endCustomersHasRegisteredProduct', e.target.checked)}
                        control={<Field type="checkbox" name="endCustomersHasRegisteredProduct" component={Checkbox} />}
                    />
                </Grid>
                {form.values.endCustomersHasRegisteredProduct &&
                    <>
                        {/* End customer email address */}
                        <Grid item xs={6}>
                            <Field
                                component={TextField}
                                name="endCustomerEmailAddress"
                                fullWidth
                                type="email"
                                variant="outlined"
                                label="End customer email address"
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Field
                                component={TextField}
                                name="productQRCode"
                                fullWidth
                                variant="outlined"
                                label="Product QR Code"
                            />
                        </Grid>
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default ProductInfo;